
// /src/utils/metricsColors.js

// 1) Brand/accessible palette (plain JS object)
export const palette = {
  indigo: '#413ea0',
  cyan: '#00bcd4',
  green: '#4caf50',
  orange: '#ff7300',
  teal: '#3ea093',
  amber: '#dc6f16',
  blue: '#1976d2',
  purple: '#7b1fa2',
  pink: '#d81b60',
  grey: '#6b7280',
};

// 2) Metric -> Color map (keys must match your dataKey names)
export const metricColorMap = {
  // Revenue, Profit & GM
  revenue: palette.indigo,
  grossProfit: palette.cyan,
  grossProfitRatioPct: palette.green,

  // Operating Performance & Margins
  operatingExpenses: palette.orange,
  operatingIncome: palette.green,
  operatingIncomeRatioPct: palette.blue,

  // Bottom line
  ebitda: palette.indigo,
  incomeBeforeTax: palette.orange,
  ebitdaMarginRatioPct: palette.green,
  incomeBeforeTaxRatioPct: palette.amber,

  // Growth
  revenueGrowth: palette.indigo,
  netIncomeGrowth: palette.cyan,
  operatingIncomeGrowth: palette.green,

  // Profitability Cascade
  netIncomeRatio: palette.orange,
  grossProfitRatioPctLine: palette.cyan, // (only if you want separate keys for lines)

  // Liquidity & Solvency
  currentRatio: palette.indigo,
  quickRatio: palette.cyan,
  debtToEquity: palette.orange,

  // Efficiency
  assetTurnover: palette.indigo,
  dsoDays: palette.orange,
  dioDays: palette.green,
  dpoDays: palette.purple,
  cccDays: palette.cyan,

  // Balance Sheet: Assets
  totalAssets: palette.indigo,
  totalCurrentAssets: palette.cyan,
  nonCurrentAssets: palette.orange,
  cashAndEquivalents: palette.green,

  // Balance Sheet: Liabilities & Equity
  totalLiabilities: palette.pink,
  totalCurrentLiabilities: palette.cyan,
  nonCurrentLiabilities: palette.orange,
  totalDebt: palette.green,
  totalEquity: palette.pink,
  netDebt: palette.purple,

  // CFO Strength
  freeCashFlow: palette.indigo,
  operatingCashFlow: palette.teal,
  fcfMarginPct: palette.cyan,
  opCashFlowMarginPct: palette.blue,

  // Cash Flow Allocation
  operatingCashflow: palette.teal,
  capitalExpenditure: palette.orange,
  capexCoverage: palette.purple,
  dividendsPaid: palette.cyan,
  commonStockRepurchased: palette.cyan,
  debtRepayment: palette.orange,
  commonStockIssuance: palette.purple,
  acquisitions: palette.pink,

  // Returns on Capital
  roePct: palette.indigo,
  roaPct: palette.cyan,
  roicPct: palette.green,

  // FCF vs Net Income
  netIncome: palette.orange,

  // Equity & Book Value
  retainedEarnings: palette.teal,

  // Debt & Coverage
  interestCoverage: palette.amber,
  netDebtLine: palette.purple,
};

// 3) Safe getter (returns grey if key not found)
export const getMetricColor = (key, fallback = palette.grey) => {
  if (!key) return fallback;
  return metricColorMap[key] || fallback;
};

// 4) Legend factory (keeps Legend colors in sync with series colors)
//   items: [{ id: 'revenue', label: 'Total Revenue', type?: 'rect'|'line' }]
export const buildLegendPayload = (items) =>
  (items || []).map(({ id, label, type }) => ({
    id,
    value: label,
    type: type || 'rect',
    color: getMetricColor(id),
  }));

